var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95898 2.29175V17.7084H9.16732C9.5125 17.7084 9.79232 17.9882 9.79232 18.3334C9.79232 18.6786 9.5125 18.9584 9.16732 18.9584H3.83398C3.21266 18.9584 2.70898 18.4547 2.70898 17.8334V2.16675C2.70898 1.54543 3.21267 1.04175 3.83398 1.04175H13.5435C13.8419 1.04175 14.1281 1.16027 14.339 1.37125L16.9628 3.99503C17.1738 4.20601 17.2923 4.49215 17.2923 4.79052V10.0001C17.2923 10.3453 17.0125 10.6251 16.6673 10.6251C16.3221 10.6251 16.0423 10.3453 16.0423 10.0001V4.8423L13.4918 2.29175H3.95898Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04232 5.00008C6.04232 4.6549 6.32214 4.37508 6.66732 4.37508H10.0007C10.3458 4.37508 10.6257 4.6549 10.6257 5.00008C10.6257 5.34526 10.3458 5.62508 10.0007 5.62508H6.66732C6.32214 5.62508 6.04232 5.34526 6.04232 5.00008ZM6.04232 8.33342C6.04232 7.98824 6.32214 7.70842 6.66732 7.70842H13.334C13.6792 7.70842 13.959 7.98824 13.959 8.33342C13.959 8.67859 13.6792 8.95842 13.334 8.95842H6.66732C6.32214 8.95842 6.04232 8.67859 6.04232 8.33342ZM6.04232 11.6667C6.04232 11.3216 6.32214 11.0417 6.66732 11.0417H9.16732C9.5125 11.0417 9.79232 11.3216 9.79232 11.6667C9.79232 12.0119 9.5125 12.2917 9.16732 12.2917H6.66732C6.32214 12.2917 6.04232 12.0119 6.04232 11.6667Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.642 16.6415C16.8861 16.3974 17.2818 16.3974 17.5259 16.6415L18.7759 17.8915C19.02 18.1356 19.02 18.5313 18.7759 18.7754C18.5318 19.0194 18.1361 19.0194 17.892 18.7754L16.642 17.5254C16.398 17.2813 16.398 16.8856 16.642 16.6415Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0007 13.1251C13.9651 13.1251 13.1257 13.9645 13.1257 15.0001C13.1257 16.0356 13.9651 16.8751 15.0007 16.8751C15.5195 16.8751 15.9881 16.6652 16.3282 16.3241C16.6672 15.9843 16.8757 15.5171 16.8757 15.0001C16.8757 13.9645 16.0362 13.1251 15.0007 13.1251ZM11.8757 15.0001C11.8757 13.2742 13.2748 11.8751 15.0007 11.8751C16.7265 11.8751 18.1257 13.2742 18.1257 15.0001C18.1257 15.8614 17.7764 16.6423 17.2133 17.2069C16.6482 17.7734 15.8649 18.1251 15.0007 18.1251C13.2748 18.1251 11.8757 16.726 11.8757 15.0001Z",
    fill: "#656579"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 1.04175C13.6792 1.04175 13.959 1.32157 13.959 1.66675V4.37508H16.6673C17.0125 4.37508 17.2923 4.6549 17.2923 5.00008C17.2923 5.34526 17.0125 5.62508 16.6673 5.62508H13.834C13.2127 5.62508 12.709 5.1214 12.709 4.50008V1.66675C12.709 1.32157 12.9888 1.04175 13.334 1.04175Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageSearch);
export default __webpack_public_path__ + "static/media/page-search.13bdec2b812b1cdc26ec862cb2a29f34.svg";
export { ForwardRef as ReactComponent };